<div #bFixContainer class="button-container">
  <button *ngIf="positiveLabel"
          mat-raised-button color="primary"
          class="smarticle_text_btn"
          [disabled]="positiveDisabled"
          (click)="positiveAction.emit()">{{positiveLabel}}
  </button>
  <button *ngIf="negativeRoute && negativeLabel" mat-raised-button class="smarticle_text_btn"
          [disabled]="negativeDisabled"
          [routerLink]="negativeRoute">{{negativeLabel}}</button>
  <button *ngIf="!negativeRoute && negativeLabel" mat-raised-button class="smarticle_text_btn"
          [disabled]="negativeDisabled"
          (click)="negativeAction.emit()">{{negativeLabel}}</button>
</div>
